import { render, staticRenderFns } from "./BoxwrapToolbar.vue?vue&type=template&id=d9dd9014"
import script from "./BoxwrapToolbar.vue?vue&type=script&lang=js"
export * from "./BoxwrapToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports